import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Notification from './../HelperElements/Notification';
import { ApiAuthRequest } from '../../services/api';
import Loading from '../HelperElements/Loader/Loading';
import './Login.css';

function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false); 

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await ApiAuthRequest('api/Auth/LoginForCms', 'POST', {
        username,
        password
      });

      if (response.token !== undefined) {
        if (response.user?.role === "Admin") {
          login(response.token);
          navigate('/dashboard');
        } else {
          setError('No cuentas con el rol necesario.');
        }
      } else {
        setError('Credenciales inválidas. Inténtalo de nuevo.');
      }
    } catch (error) {
      let mensaje = 'Error al hacer la solicitud.';

      if (error?.data?.error) {
        mensaje = error.data.error;
      }

      setError(mensaje);
      console.error('Error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseNotification = () => {
    setError(null);
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}
    >
      {error && (
        <Notification title="Error" message={error} onClose={handleCloseNotification} />
      )}

      {isLoading ? (
        <div style={{ marginTop: 40 }}>
          <Loading />
        </div>
      ) : (
        <div className="login-container">
          <form className="login-form" onSubmit={handleLogin}>
            <p className="heading">Hoy Toca</p>
            <p className="paragraph">Ingresa con tu cuenta de administrador</p>

            <div className="input-group">
              <input
                type="email"
                placeholder="Email"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>

            <div className="input-group">
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <button type="submit">Ingresa</button>
          </form>
        </div>
      )}
    </div>
  );
}

export default Login;
